import React from 'react';
import * as XLSX from 'xlsx';
import moment from "moment";
import { getIcons } from '_helpers';

export {DownloadButton};

function DownloadButton ({ data = [], headers = [], title = "myFile" }) {
  /**
   * Function pour transformer les objets individuellement
   * Vérifie si la clé contient 'CONTEXTE.' et traite cette clé de manière spéciale
   * @param {*} originalObject 
   * @returns 
   */
  const transformObject = (originalObject) => {
    const transformedObject = {};

    headers.forEach(({ label, key, icon }) => {
      if (key.startsWith('CONTEXT.')) {
        // On extrait la partie après 'CONTEXT.' On enlève 'CONTEXT.' et on garde la partie qui suit
        const contextKey = key.split('CONTEXT.')[1];

        // Vérifie si l'objet original contient un 'CONTEXT' et si la clé existe dans CONTEXT
        if (originalObject.CONTEXT && originalObject.CONTEXT[contextKey] !== undefined) {
          transformedObject[label] = originalObject.CONTEXT[contextKey] ?? '';
        } else {
          transformedObject[label] = '';  // Si la clé n'existe pas, on met une valeur vide
        }
      } else {
        // Cas standard : on prend la valeur depuis 'key' ou 'icon'
        transformedObject[label] = originalObject[key] ?? originalObject[icon] ?? '';
      }
    });

    return transformedObject;
  };
  const downloadExcel = () => {
    const transformedArray = data.map(transformObject);
    const ExcelTitle = title + "_" + moment(new Date()).format('DD/MM/YYYY');
    const worksheet = XLSX.utils.json_to_sheet(transformedArray);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, 'my sheet');
    XLSX.writeFile(workbook, ExcelTitle + ".xlsx");
  };

  return (
    <button className="btn-custom btn-custom-primary" onClick={downloadExcel}>
      <img src={getIcons('fileDownloadOutlinedWhite')} className="btn-custom-icon" alt="excel" />
      Télécharger
    </button>
  );
};
